/*
 * @Description: 所有请求的接口入口
 * @Author: gao shuai
 * @Date: 2020-02-25 15:35:05
 * @LastEditTime: 2020-06-21 15:16:26
 * @LastEditors: gao shuai
 */
import home from './home';
const _api = {
  home
};

export default _api;
